<mat-card class="mat-card--task">
    <app-shared-task *ngIf="task.uid && user.uid" [taskInp]="task" [userInp]="user" [viewInp]="'page'" class="app-shared-task"></app-shared-task>
</mat-card>
